<template>
  <!-- 积分商城-积分礼品 -->
  <div class="points_gift">
    <!-- 优惠券列表 -->
    <ul class="list" v-show="!couponsIsShow">
      <li class="wrap">
        <div class="item">
          <img src="../../assets/images/integralCenter/exchange_1.svg" alt="" />
          <span class="name">兑换优惠券</span>
          <button v-zoom="{ from: '忠诚度管理-积分商城', name: '创建兑换优惠券' }" class="createBtn" @click="couponsChange(true, 1)">
            创建
          </button>
        </div>
      </li>
      <li class="wrap">
        <div class="item">
          <img src="../../assets/images/integralCenter/exchange_2.svg" alt="" />
          <span class="name">兑换实物</span>
          <button v-zoom="{ from: '忠诚度管理-积分商城', name: '创建兑换实物' }" class="createBtn" @click="couponsChange(true, 2)">
            创建
          </button>
        </div>
      </li>
    </ul>

    <!-- 创建积分优惠券 -->
    <create-coupons :isShow="couponsIsShow" :tabActive="tabActive" @return="couponsChange(false, 3)"></create-coupons>
  </div>
</template>

<script>
import createCoupons from "./create_coupons";

export default {
  components: {
    createCoupons,
  },
  data() {
    return {
      // 创建积分优惠券显示隐藏状态控制
      couponsIsShow: false,
      tabActive: 10,
    };
  },
  methods: {
    /**
     * 优惠券组件显示隐藏 && 显示隐藏导航栏
     */
    couponsChange(flag, index) {
      //console.log(index);
      if (flag) {
        this.$emit("navTabChange", false);
        this.couponsIsShow = true;
      } else {
        this.$emit("navTabChange", true);
        this.couponsIsShow = false;
      }
      if (index == 1) {
        this.tabActive = 10;
      } else if (index == 2) {
        this.tabActive = 9;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.points_gift {
  min-width: 966px;
  min-height: 880px;
  .list {
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    padding: 30px 20px;
    min-width: 1366px;
    .wrap {
      width: 16.6%;
      height: 240px;
      padding: 0 8px;
      margin-bottom: 20px;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        border: 1px solid #eee;
        height: 100%;
        border-radius: 6px;
        box-sizing: border-box;
        background-color: #fff;
        box-shadow: 2px 2px 8px rgba(139, 156, 188, 0.15) !important;
        &:hover {
          // border: 1px solid #fe4d45;
          box-shadow: 2px 2px 16px rgba(86, 118, 179, 0.15) !important;
        }
        img {
          width: 60px;
          height: 46px;
          margin-top: 50px;
        }
        .name {
          margin-top: 40px;
          font-size: 16px;
          color: #333;
        }
        .createBtn {
          width: 92px;
          height: 32px;
          line-height: 28px;
          margin-top: 20px;
          text-align: center;
          outline: none;
          cursor: pointer;
          background-color: white;
          border-radius: 2px;
          border: 1px solid #fe4d45;
          color: #fe4d45;
          font-size: 14px;
          transition: all 0.2s;
          &:hover {
            background-color: #fe4d45;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
